import { render, staticRenderFns } from "./PaymentStatementMetaSetting.vue?vue&type=template&id=177af1da&lang=pug"
import script from "./PaymentStatementMetaSetting.vue?vue&type=script&lang=js"
export * from "./PaymentStatementMetaSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports